// extracted by mini-css-extract-plugin
module.exports = {"display":"SubAssemblyLive_display__2eLEC","header":"SubAssemblyLive_header__2WWPW","tableArea":"SubAssemblyLive_tableArea__2K7FP","footer":"SubAssemblyLive_footer__xvwaA"};